import type { FourPillars } from '../types/pillars';
import type { SinsalAnalysis, SinsalEmphasis } from '../types/sinsal';
import { findTwelveSinsal } from './twelve-sinsal';
import { findGeneralSinsal } from './general-sinsal';

export function analyzeSinsal(fourPillars: FourPillars, noHour?: boolean, emphasis?: SinsalEmphasis, gender?: 'male' | 'female'): SinsalAnalysis {
  const twelveByYear = findTwelveSinsal(fourPillars, 'year', noHour);
  const twelveByDay = findTwelveSinsal(fourPillars, 'day', noHour);
  const twelveByMonth = findTwelveSinsal(fourPillars, 'month', noHour);
  const generalSinsal = findGeneralSinsal(fourPillars, noHour, gender);

  return {
    entries: [...twelveByYear, ...twelveByDay, ...twelveByMonth, ...generalSinsal],
    emphasis,
  };
}

export { findTwelveSinsal, findGeneralSinsal };
